import { render, staticRenderFns } from "./emar.vue?vue&type=template&id=0d85d6e0&scoped=true&"
import script from "./emar.vue?vue&type=script&lang=js&"
export * from "./emar.vue?vue&type=script&lang=js&"
import style0 from "./emar.vue?vue&type=style&index=0&id=0d85d6e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85d6e0",
  null
  
)

export default component.exports